'use client';
import create from 'zustand';

const initialState = {
  isExperienceDisabled: false,
};

interface DisableState {
  isExperienceDisabled: boolean;
  setIsExperienceDisabled: (disabled: boolean) => void;
  resetState: () => void;
}

export const useDisableStore = create<DisableState>(set => ({
  ...initialState,
  setIsExperienceDisabled: disabled => set({ isExperienceDisabled: disabled }),
  resetState: () => set(initialState),
}));
